import React from "react";
import ConvertBand from "./ConvertBand";

/** Single closing conversion for the landing page */
const Cta = () => (
  <ConvertBand
    id="cta-container"
    eyebrow="Join OllaCart"
    title="Start free. Shop better. Share when you want."
    body="Save across stores, get feedback from people you trust, and check out when it feels right on the web or iPhone."
    primaryLabel="Start free"
    tertiaryTo="/about"
    tertiaryLabel="Read why we built OllaCart"
  />
);

export default Cta;
